export default "__VITE_ASSET__BSdPIb$D__"